
$(document).ready(function(){
  
 $('.slick01').slick({
 centerMode: true,
  slidesToShow: 2,
  dots: true,
  autoplay: true,
  autoplaySpeed: 3500,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        centerMode: true,
        centerPadding: '40px',
        dots: true,
        autoplay: true,
        autoplaySpeed: 3500,
        slidesToShow: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        arrows: false,
        centerMode: false,
        centerPadding: '0',
         dots: true,
        autoplay: true,
        autoplaySpeed: 3500,
        slidesToShow: 1
      }
    }
  ]
});


 $('.slick02').slick({
  slidesToShow: 4,
  centerMode: true,
  centerPadding: '0px',
  autoplay: true,
  slidesToScroll: 1,
  autoplaySpeed: 3500,
   arrows: true,
   prevArrow: '<div class="slide-arrow prev-arrow"></div>',
   nextArrow: '<div class="slide-arrow next-arrow"></div>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '30px',
        slidesToScroll: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 3500,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        centerPadding: '30px',
         dots: false,
        autoplay: true,
        autoplaySpeed: 3500,
        slidesToScroll: 1,
        slidesToShow: 1        
      }
    }
  ]
});


 $('.slick03').slick({
  slidesToShow: 4,
  centerMode: true,
  centerPadding: '0px',
  autoplay: true,
  slidesToScroll: 1,
  autoplaySpeed: 4000,
   arrows: true,
   prevArrow: '<div class="slide-arrow prev-arrow"></div>',
   nextArrow: '<div class="slide-arrow next-arrow"></div>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '0px',
        slidesToScroll: 1,
        dots: true,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToShow: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        centerPadding: '0px',
         dots: true,
        autoplay: true,
        autoplaySpeed: 4000,
        slidesToScroll: 1,
        slidesToShow: 1        
      }
    }
  ]
});
  
});   
